module.exports = __webpack_public_path__ + "img/search-hero-overflow-chevy.c2b7c2fa.png";